//TODO: adding config options fallbacks
//TODO: refactor after MyAllocatableEntries has been moved to sg-ui-components
//TODO: resolveCurrency should be refactored and moved to sg-ui-components

import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'react-bootstrap';
import {
    getCMSObject,
    MyCouponsHistory,
    MyRewardsHistory,
    MyTicketHistory,
    MyDrawingEntries,
    MyPoints,
    TeleScript,
    ErrorBoundary,
    MyPointsForDrawing,
    DisplayContent,
    MyAllocatableEntries,
    getConfigForComponent,
} from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';

import WinnerLinkWrapper from '../Components/WinnerLinkWrapper';
import AllocatableEntriesForm from '../Components/AllocatableEntries/AllocatableEntriesForm';
import siteConfig from '../promotionConfig';

const MyActivityPage = ({ user, coupon, points, winner, reward, pointsForDrawings, activity, config, cmsSourceFirebase, actions, match, sweep, loading }) => {
    const lotteryLogo = getCMSObject('data.sitewideSettings.alternateLogo.image.imageSrc');
    const myDrawingEntries = getConfigForComponent('myDrawingEntries', config);
    const myTicketHistory = getConfigForComponent('myTicketHistory', config);
    const myCouponsHistory = getConfigForComponent('myCouponsHistory', config);
    const myAllocatable = getConfigForComponent('myAllocatableEntries', config);
    const myRewardsHistory = getConfigForComponent('myRewardsHistory', config);
    const myPointsForDrawing = getConfigForComponent('myPointsForDrawing', config);
    const myPointsHistory = getConfigForComponent('myPointsHistory', config);

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, activity, match }}>
            <Container>
                <DisplayContent note='Show My Allocatable Entries History section' isVisible={myAllocatable?.enabled}>
                    <ErrorBoundary fallback={<TeleScript line={myAllocatable?.fallback} />} details={{ user, config, reward }}>
                        <MyAllocatableEntries
                            options={{
                                variant: 'theme-blue',
                                hasCollapser: true,
                                showByDefault: true,
                                hash: 'allocatable-entries',
                            }}
                            actions={actions}
                            sweep={sweep}
                            loading={loading}
                            AllocatableForm={(entry) => (
                                <AllocatableEntriesForm
                                    sweepId={entry.sweeps_id ?? ''}
                                    promotionName={entry.sweepstake_name ?? ''}
                                    numEntries={entry.quantity ?? ''}
                                    entryId={entry.id ?? ''}
                                />
                            )}
                            telescript={myAllocatable?.telescript}
                        />
                    </ErrorBoundary>
                </DisplayContent>
                <DisplayContent note='Show My Drawing Entries section' isVisible={myDrawingEntries?.enabled}>
                    <ErrorBoundary fallback={<TeleScript line={myDrawingEntries?.fallback} />} details={{ user, config, reward }}>
                        <MyDrawingEntries
                            winner={winner}
                            actions={actions}
                            telescript={myDrawingEntries?.telescript}
                            WinnerLink={WinnerLinkWrapper}
                            options={{
                                variant: 'theme-primary',
                                hasCollapser: true,
                                showByDefault: false,
                                hash: 'drawing-entries',
                                pageSize: myDrawingEntries?.config?.defaultPageSize ?? 5,
                                promotionDetailsLink: '/second-chance-promotion',
                            }}
                        />
                    </ErrorBoundary>
                </DisplayContent>
                <DisplayContent note='Show My Points For Drawings History section' isVisible={myPointsForDrawing?.enabled}>
                    <ErrorBoundary fallback={<TeleScript line={myPointsForDrawing?.fallback} />} details={{ user, config, reward }}>
                        <MyPointsForDrawing
                            pointsHistory={pointsForDrawings?.playerPFDTransactions}
                            actions={actions}
                            telescript={myPointsForDrawing?.telescript}
                            options={{
                                variant: 'theme-primary',
                                hasCollapser: true,
                                hash: 'points-history',
                                pageSize: myPointsForDrawing?.config?.defaultPageSize ?? 5,
                                linkOlderDrawings: `${config.config.store_uri}/users/drawing_orders.php`,
                            }}
                        />
                    </ErrorBoundary>
                </DisplayContent>
                <DisplayContent note='Show My Points History section' isVisible={myPointsHistory?.enabled}>
                    <ErrorBoundary fallback={<TeleScript line={myPointsHistory?.fallback} />} details={{ user, config, reward }}>
                        <MyPoints
                            points={points}
                            actions={actions}
                            telescript={myPointsHistory.telescript}
                            options={{
                                variant: 'theme-primary',
                                hasCollapser: true,
                                hash: 'points-history',
                                pageSize: config?.site?.components?.pointHistory?.defaultPageSize ?? 5,
                            }}
                        />
                    </ErrorBoundary>
                </DisplayContent>
                <DisplayContent note='Show My Coupons History section' isVisible={myCouponsHistory?.enabled}>
                    <ErrorBoundary fallback={<TeleScript line={myCouponsHistory?.fallback} />} details={{ user, config, reward }}>
                        <MyCouponsHistory
                            coupon={coupon}
                            actions={actions}
                            telescript={myCouponsHistory?.telescript}
                            lotteryLogo={lotteryLogo}
                            barcodeHost={config.config.barcode_image_host}
                            options={{
                                variant: 'theme-primary',
                                hasCollapser: true,
                                hash: 'coupons-history',
                                pageSize: myCouponsHistory?.config?.defaultPageSize ?? 5,
                            }}
                        />
                    </ErrorBoundary>
                </DisplayContent>
                <DisplayContent note='Show My Ticket History section' isVisible={myTicketHistory?.enabled}>
                    <ErrorBoundary fallback={<TeleScript line={myTicketHistory?.fallback} />} details={{ user, config, reward }}>
                        <MyTicketHistory
                            activity={activity}
                            actions={actions}
                            telescript={myTicketHistory?.telescript}
                            options={{
                                variant: 'theme-primary',
                                hasCollapser: true,
                                hash: 'ticket-history',
                                pageSize: myTicketHistory?.config?.defaultPageSize ?? 5,
                                promotionsLink: '/promotions',
                            }}
                            resolveCurrency={siteConfig.resolveCurrency}
                        />
                    </ErrorBoundary>
                </DisplayContent>
                <DisplayContent note='Show My Rewards History section' isVisible={myRewardsHistory?.enabled}>
                    <ErrorBoundary fallback={<TeleScript line={myRewardsHistory?.fallback} />} details={{ user, config, reward }}>
                        <MyRewardsHistory
                            reward={reward}
                            actions={actions}
                            telescript={myRewardsHistory?.telescript}
                            options={{
                                variant: 'theme-primary',
                                hasCollapser: true,
                                hash: 'rewards-history',
                                pageSize: myRewardsHistory?.config?.defaultPageSize ?? 5,
                                promotionsLink: '/promotions',
                            }}
                            resolveCurrency={siteConfig.resolveCurrency}
                        />
                    </ErrorBoundary>
                </DisplayContent>
            </Container>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyActivityPage);
